// extracted by mini-css-extract-plugin
export default {"Switch":"Form_Switch__Gg0nB"};